






















import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

export interface Result {
  id: number
  icon: {
    name: string
    color?: string
  }
  text: string
  subtext?: string
}

@Component({})
export default class Home extends Vue {
  @Prop()
  public results: Result[]

  @Prop()
  public title?: string

  get hasSubtext() {
    return (
      this.results &&
      !!this.results.length &&
      this.results[0].hasOwnProperty('subtext')
    )
  }
}
